"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tuple = void 0;
/**
 * @hidden
 *
 * Create a literal tuple type from a list of arguments
 *
 * @param args - values to turn into a tuple
 */
const tuple = (...args) => args;
exports.tuple = tuple;
//# sourceMappingURL=index.js.map